module.exports = __webpack_public_path__ + "img/Logo_cidade.0c74d136.png";